module.exports = __webpack_public_path__ + "static/media/deu.292a02ed.svg";